import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui convention: merge Tailwind classes without duplicates. */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
